import styled from "styled-components";

export const Divider = styled.div`
  border-top: 1px solid #dddddd;
`;

interface DividerProps {
  mb?: number;
  mt?: number;
  mr?: number;
  ml?: number;
  vertical?: boolean;
  horizontal?: boolean;
  orientation?: "vertical" | "horizontal";
  width?: string;
}

export const DividerContainer = styled.div<DividerProps>`
  ${(props) =>
    props.vertical
      ? `
    height: 100%;
    border-right: ${props.width || props.theme.DividerContainerWidth} solid;
  `
      : `
    width: 100%;
    border-top: ${props.width || props.theme.DividerContainerWidth} solid;
  `}
  border-color: ${({ theme }) => theme.borderColor};
`;
